import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CourseCard({ course, index = 0 }) {
  return (
    <article
      className={`group relative bg-[#141414] text-white border border-[#2A2A2A] p-8 md:p-10 flex flex-col justify-between transition-all duration-300 hover:border-[#FFD60A] hover:-translate-y-1 fade-up delay-${
        index + 1
      }`}
      data-testid={`course-card-${course.id}`}
    >
      <div>
        <div className="flex items-center justify-between mb-8">
          <span className="bg-[#FFD60A] text-black text-[10px] uppercase tracking-[0.25em] font-bold px-2.5 py-1">
            {course.badge}
          </span>
          <span className="text-[11px] uppercase tracking-[0.25em] text-white/50 font-bold">
            {course.duration}
          </span>
        </div>

        <h3 className="font-display text-3xl md:text-4xl uppercase leading-[1] mb-4">
          {course.title}
        </h3>
        <p className="text-white/70 text-[15px] leading-relaxed mb-8">
          {course.desc}
        </p>
      </div>

      <div className="flex items-end justify-between border-t border-[#2A2A2A] pt-6">
        <div>
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/50 font-bold mb-1">
            Tuition
          </p>
          <p className="font-display text-4xl text-[#FFD60A] leading-none">
            {course.price}
          </p>
        </div>
        <Link
          to="/book"
          data-testid={`course-enroll-${course.id}`}
          className="inline-flex items-center gap-2 bg-[#FFD60A] text-black px-5 py-3 font-bold uppercase tracking-wider text-[12px] hover:bg-white transition-colors"
        >
          Enroll <ArrowUpRight className="w-4 h-4" />
        </Link>
      </div>
    </article>
  );
}
